<template>
  <div id="quote-order" class="order-steps-container">
    <arch
      @go-to-step="goToStep"
      :titles="steps"
      :activeStep="activeStep"
      :errors="quoteOrderStore.orderErrors.length"
      @submit-order="sendOrder"
    ></arch>
    <router-view></router-view>
  </div>
</template>

<script>
import Arch from '@/components/Arch.vue'
import { EventBus } from '@/eventbus/EventBus'

import isEmpty from 'lodash-es/isEmpty'

import { requestQuotation } from './QuoteOrderApi'
import cloneDeep from 'lodash-es/cloneDeep'
import OrderMixin from '@/mixins/OrderMixin'

import SendingOrder from '@/dialogs/SendingOrder.vue'
import ErrorMessage from '@/dialogs/ErrorMessage.vue'
import QuoteOrderConfirm from '@/dialogs/QuoteOrderConfirm.vue'
import { useFileListStore } from '@/stores/FileList.store'

import { mapStores } from 'pinia'
import { useQuoteOrderStore } from '@/features/quoteOrder/QuoteOrder.store'
import clickOutside from '../../directives/clickOutside'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE } from '@/stores/store'

export default {
  data() {
    return {
      step: 'step1',
      steps: ['Opdracht', 'Bezorgen', 'Afrekenen', 'Controleren'],
      inProgress: false
    }
  },
  mixins: [OrderMixin],
  components: {
    Arch
  },
  methods: {
    goToStep(step) {
      switch (step) {
        case 'step1':
          this.$router.push({
            name: 'quoteOrderDescription'
          })
          break
        case 'step2':
          this.$router.push({
            name: 'quoteOrderDeliver'
          })
          break
        case 'step3':
          this.$router.push({
            name: 'quoteOrderInvoice'
          })
          break
        case 'step4':
          this.$router.push({
            name: 'quoteOrderConfirm'
          })
          break
      }
    },
    updateOrder(key, val) {
      this.quoteOrderStore.updateOrderDetails(key, val)
    },
    sendOrder() {
      if (this.inProgress) return
      this.inProgress = true
      const order = cloneDeep(this.quoteOrderStore.orderDetails)

      order.sessionId = Cookies.get(UPLOAD_COOKIE)

      order.project = order.project.name

      this.$modal.show(SendingOrder, null, {
        height: 120,
        width: 280,
        adaptive: true,
        name: 'sending'
      })

      //console.log(order)

      requestQuotation(order).then(
        (resp) => {
          this.$modal.hide('sending')
          this.inProgress = false
          this.$modal.show(
            QuoteOrderConfirm,
            {
              callback: (model) => {
                this.fileListStore.removeAllFiles()
                this.quoteOrderStore.resetOrder()
              }
            },
            {
              height: 163,
              width: 360,
              adaptive: true,
              clickToClose: false
            },
            {
              'before-close': () => {
                this.step = 'step1'
              }
            }
          )
        },
        (resp) => {
          this.fileListStore.removeAllFiles()
          this.$modal.hide('sending')
          this.inProgress = false
          this.$modal.show(
            ErrorMessage,
            {
              title: 'Probleem bij het verzenden van uw offerte',
              text: resp.message
            },
            {
              height: 250,
              width: 380,
              adaptive: true
            }
          )
        }
      )
    }
  },
  computed: {
    ...mapStores(useQuoteOrderStore, useFileListStore),
    activeStep() {
      if (this.$route.name === 'quoteOrderDescription') {
        return 'step1'
      } else if (this.$route.name === 'quoteOrderDeliver') {
        return 'step2'
      } else if (this.$route.name === 'quoteOrderInvoice') {
        return 'step3'
      } else if (this.$route.name === 'quoteOrderConfirm') {
        return 'step4'
      }
    }
  },
  created() {
    if (isEmpty(this.quoteOrderStore.orderDetails.deliveryAddress)) {
      const deliveryAddress = this.setDeliveryAddress()

      this.quoteOrderStore.updateOrderDetails(
        'deliveryAddress',
        deliveryAddress
      )
    }

    if (isEmpty(this.quoteOrderStore.orderDetails.invoiceAddress)) {
      const invoiceDetails = this.getDefaultInvoiceDetails()

      this.quoteOrderStore.updateOrderDetails(
        'invoiceAddress',
        invoiceDetails.address
      )
    }

    EventBus.on('submitOrder', this.sendOrder)
  },
  unmounted() {
    EventBus.off('submitOrder', this.sendOrder)
  }
}
</script>
<style lang="scss">
.quote-card .two-col-res > div:first-child {
  //  max-width: 700px;
  display: block;
}
</style>
<style lang="scss" scoped>
#quote-order {
  max-width: 840px;
}
</style>
